import React, { forwardRef } from 'react';
import ListItem from '@material-ui/core/ListItem';
import { NavLink, NavLinkProps } from 'react-router-dom';

export interface AppMenuItemComponentProps {
    className?: string;
    link?: string | null;
    onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const AppMenuItemComponent: React.FC<AppMenuItemComponentProps> = (props) => {
    const { className, link, children } = props;

    return (
        <ListItem
            button
            className={className}
            component={forwardRef((props: NavLinkProps, ref: any) => (
                <NavLink exact {...props} innerRef={ref} />
            ))}
            to={`${link}`}
        >
            {children}
        </ListItem>
    );
};

export default AppMenuItemComponent;
